import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { uniq } from 'lodash';

type OnChangeFunction = (value: string[]) => void;
type OnTouchFunction = () => void;

@Component({
  selector: 'la-checkbox-multiselect',
  templateUrl: './checkbox-multiselect.component.html',
  styleUrl: './checkbox-multiselect.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCheckboxModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxMultiselectComponent),
      multi: true,
    },
  ],
})
export class CheckboxMultiselectComponent {
  @Input() options: { value: string; label: string }[] = [];
  @Input() maxSelection?: number;

  private results: string[] = [];

  onChange: OnChangeFunction = () => {
    /* empty */
  };
  onTouch: OnTouchFunction = () => {
    /* empty */
  };

  registerOnChange(fn: OnChangeFunction): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: OnTouchFunction): void {
    this.onTouch = fn;
  }

  writeValue(input: string[]) {
    this.results = input;
  }

  onChecked(value: string, checked: boolean) {
    if (checked) {
      if (this.maxSelection === 1) {
        this.results = [value];
      } else {
        const next = uniq([...this.results, value]);

        if (this.maxSelection && next.length > this.maxSelection) {
          return;
        }

        this.results = next;
      }
    } else {
      this.results = this.results.filter((v) => v !== value);
    }

    this.onChange(this.results);
  }

  isChecked(value: string) {
    return this.results.includes(value);
  }
}
